import {GeomObject} from "./geom-object";
import cabri from "../app/cabri-app";
import * as BABYLON from "babylonjs/babylon.max";

class Line extends GeomObject {
    constructor (objectId) {
        super(objectId);
        this.color =
            this.curve_color1 =
                super.getColorAttribute("curve_color1", "#7F7F7F");
        this.curve_radius = super.getFloatStyleAttribute("curve_radius", 1.0);
        this.coords = [0, 0, 0, 0, 0, 0];

    }

    createTube () {
        if (this.bSegment) this.bSegment.dispose(false, true);
        if (this.noDisplay || this.hidden) return;
        const r = this.radius,
            c = this.coords;
        let a = new BABYLON.Vector3(c[0] + r * c[3], c[2] + r * c[5],
            c[1] + r * c[4]),
            b = new BABYLON.Vector3(c[0] - r * c[3], c[2] - r * c[5],
                c[1] - r * c[4]);

        /** debug: display spheres at important points
         let t = BABYLON.MeshBuilder.CreateSphere("debug", {diameter: 0.2}, cabri.scene);
         t.position = new BABYLON.Vector3(c[0],c[2],c[1]); this.markColor(t, "violet");
         t = BABYLON.MeshBuilder.CreateSphere("debug", {diameter: 0.2}, cabri.scene);
         t.position = new BABYLON.Vector3(c[0]+c[3], c[2]+c[5], c[1]+c[4]); this.markColor(t, "violet");
         t = BABYLON.MeshBuilder.CreateSphere("debug", {diameter: 0.2}, cabri.scene);
         t.position  = new BABYLON.Vector3(c[0]-c[3], c[2]-c[5], c[1]-c[4]); this.markColor(t, "violet");
         */

        this.bSegment = BABYLON.MeshBuilder.CreateTube("Line" + this.objectId,
            {path: [a, b], radius: 0.05 * this.curve_radius}, cabri.scene);
        //this.bSegment.isVisible = false
        this.bSegment.cabriPeer = this;
        super.markColor(this.bSegment, this.curve_color1);
        //this.registerHighlighter(this.bSegment);
    }

    highlight (active) {
        if (typeof (this.highlighted) === "undefined") this.highlighted = false;
        if (typeof (active) === "undefined") active = !this.highlighted;
        if (this.highlighted !== active) {
            this.highlightThisPeer(this.bSegment, active);
        }
        this.highlighted = active;
    }

    updateFromPeer () {
        let v = null;
        try {
            if (this.alreadyCheckedInLastCycle) {
                return this.updatedInLastCycle;
            }
            this.alreadyCheckedInLastCycle = true;
            v = cabri.emsc.getLineCenterAndDirection(this.objectId);
            let e = true, c = this.coords;
            for (let i = 0; i < 6; i++) {
                e = e && v[i] === c[i];
            }
            const newRadius = 10 * cabri.camera.radius;
            if (!e || newRadius !== this.radius) {
                this.updatedInLastCycle = true;
                this.radius = newRadius;
                for (let i = 0; i < 6; i++) {
                    c[i] = v[i];
                }
                this.createTube();
            }
        } catch (e) {
            console.log(
                "Trouble at updateFromPeer (" + this.constructor.name + ").");
            console.log(e);
        } finally {
            if (v) cabri.emsc._free(v);
        }
    }

    dispose () {
        if (this.bSegment)
            this.bSegment.dispose(false, true);
        super.dispose();
    }
}

export {Line};